import './style.sass';
import React from 'react';

function MarkIcon({ scale = 1, marked = false }) {
  return (
    <span
      className={`mark_icon${marked ? ' icon_marked' : ''}`}
      style={{ transform: `scale(${scale})` }}
    ></span>
  );
}

export default MarkIcon;
